import freele from "../../assets/images/freele.png";
import devBlog from "../../assets/images/dev-blog.png";
import coachingManagement from "../../assets/images/coachingManagement.png";
import shoppingCart from "../../assets/images/shoppingCart.png";
import burgerBuilder from "../../assets/images/burgerBuilder.png";
import devIt from "../../assets/images/DEV-IT-webDesignProjects.png";
import bitmWeb from "../../assets/images/bitmWebDesignProject.png";
import parkingManagement from "../../assets/images/parkingManagementProject.png";
import todo from "../../assets/images/toDoList.png";
import simpleReact from "../../assets/images/simplpeReactProjects.png";

export const projectData = [
	{
		id: 1,
		projectName: "Freele: Online Marketplace for Freelance Services",
		img: freele,
		demo: "https://freele.onrender.com",
		code: "https://github.com/JAHID6597/freele"
	},
	{
		id: 2,
		projectName: "DEV Blog",
		img: devBlog,
		demo: "https://dev-blog-forem.netlify.app",
		client: "https://github.com/JAHID6597/blog-client",
		server: "https://github.com/JAHID6597/blog-server"
	},
	{
		id: 3,
		projectName: "Coaching Management System",
		img: coachingManagement,
		demo: "",
		code: "https://github.com/JAHID6597/Coaching-Management-project"
	},
	{
		id: 4,
		projectName: "Shopping Cart",
		img: shoppingCart,
		demo: "https://shoppingcarted.netlify.app",
		code: "https://github.com/JAHID6597/Shopping-Cart"
	},
	{
		id: 5,
		projectName: "Burger Builder",
		img: burgerBuilder,
		demo: "https://easyburgerbuilder.netlify.app",
		code: "https://github.com/JAHID6597/Burger-Builder"
	},
	{
		id: 6,
		projectName: "DEV IT Web Design Project",
		img: devIt,
		demo: "https://jahid6597.github.io/webDesign_Project",
		code: "https://github.com/JAHID6597/webDesign_Project"
	},
	{
		id: 7,
		projectName: "BITM  Web Design Project",
		img: bitmWeb,
		demo: "https://jahid6597.github.io/bitm-finalProject-webDesign/index.html",
		code: "https://github.com/JAHID6597/bitm-finalProject-webDesign"
	},
	{
		id: 8,
		projectName: "Parking Management",
		img: parkingManagement,
		demo: "",
		code: "https://github.com/JAHID6597/Parking-Management.-Qt-project"
	},
	{
		id: 9,
		projectName: "MERN To do List",
		img: todo,
		demo: "https://todolist4u.netlify.app/",
		client: "https://github.com/JAHID6597/mern-todo-client",
		server: "https://github.com/JAHID6597/mern-todo-server"
	},
	{
		id: 10,
		projectName: "Simple React Project",
		img: simpleReact,
		demo: "https://simple-react-projects.netlify.app",
		code: "https://github.com/JAHID6597/Simplpe-React-Projects"
	}
];
